export const ROUTE_DATA_CACHE_KEY = "routeDataCache";
export const STAGE_FILTER_STATE_KEY = "stageFilterState";
export const DEPART_FILTER_STATE_KEY = "departFilterState";


// WEBPACK FOOTER //
// ./src/components/util/LocalStorageKeys.js